<ngb-alert [hidden]="!show" [type]="'danger'" [dismissible]="false">
  <ng-container *ngIf="user.admin">
    Your account has reached a usage cap for performance events. Adjust usage
    caps on your
    <a class="alert-link" href="/account/edit#tab-usage-caps" target="_self">
      account settings</a
    >
    to accept additional events in this billing cycle.
  </ng-container>

  <ng-container *ngIf="!user.admin">
    Your account has reached a usage cap for performance events. Please contact
    your account admin to adjust usage caps to accept additional events in this
    billing cycle.
  </ng-container>
</ngb-alert>
